import { useApp } from '@/context/AppContext';
import { useFeature } from '@/hooks/useFeature';

export default function ChemLog() {
  const { activeStop, custById, logChem, setMobileScreen } = useApp();
  const hasVoice = useFeature('voice_logging');

  const stop = activeStop;
  const c    = stop ? custById(stop.custId) : null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!stop) return;
    const fd = new FormData(e.target);
    const d  = Object.fromEntries(fd);
    logChem(stop.id, {
      cl:  parseFloat(d.cl),
      ph:  parseFloat(d.ph),
      alk: parseInt(d.alk),
      cya: parseInt(d.cya),
    }, d.notes || '');
    setMobileScreen('stop');
  };

  return (
    <div className="mobile-page">
      {/* Hero header */}
      <div
        className="mobile-hero"
        style={{ margin: '-14px -16px 0', padding: '14px 16px 16px' }}
      >
        <button className="m-back" onClick={() => setMobileScreen('stop')}>
          ← {c?.name || 'Stop'}
        </button>
        <div style={{ fontSize: 17, fontWeight: 800, color: 'var(--t1)', letterSpacing: '-.3px' }}>
          Log Water Chemistry
        </div>
        <div style={{ fontSize: 12, color: 'var(--t3)', marginTop: 3 }}>
          Enter current readings from your test kit
        </div>
      </div>

      {/* Voice entry banner */}
      <div style={{
        padding: '8px 12px',
        borderRadius: 10,
        background: 'rgba(155,109,255,.08)',
        border: '1px solid rgba(155,109,255,.2)',
        display: 'flex',
        gap: 10,
        alignItems: 'center',
      }}>
        <div style={{
          width: 36,
          height: 36,
          borderRadius: '50%',
          background: 'var(--violet)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 18,
          flexShrink: 0,
        }}>🎤</div>
        <div style={{ fontSize: 12.5, color: 'var(--t2)', lineHeight: 1.5 }}>
          {hasVoice ? (
            <><strong style={{ color: 'var(--violet)' }}>Voice entry</strong> — coming soon</>
          ) : (
            <><strong style={{ color: 'var(--t3)' }}>Voice Entry</strong> — enable in Settings &gt; Plugins</>
          )}
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        {/* Readings */}
        <div className="m-card">
          <div style={{
            padding: '9px 14px',
            borderBottom: '1px solid var(--b1)',
            fontSize: 11,
            fontWeight: 700,
            color: 'var(--t3)',
            textTransform: 'uppercase',
            letterSpacing: '.06em',
          }}>
            Readings
          </div>
          {[
            { name: 'cl',  label: 'Free Chlorine', placeholder: '2.4', step: '0.1', max: '10', unit: 'ppm' },
            { name: 'ph',  label: 'pH',             placeholder: '7.4', step: '0.1', max: '10', unit: '' },
            { name: 'alk', label: 'Alkalinity',     placeholder: '95',  step: '1',   max: '300', unit: 'ppm' },
            { name: 'cya', label: 'CYA',            placeholder: '40',  step: '1',   max: '200', unit: 'ppm' },
          ].map(field => (
            <div key={field.name} className="m-chem-input">
              <div className="m-ci-label">{field.label}</div>
              <input
                className="m-ci-field"
                name={field.name}
                type="number"
                step={field.step}
                placeholder={field.placeholder}
                min="0"
                max={field.max}
                required
              />
              <div className="m-ci-unit">{field.unit}</div>
            </div>
          ))}
        </div>

        {/* Notes */}
        <div className="m-card">
          <div style={{
            padding: '9px 14px',
            borderBottom: '1px solid var(--b1)',
            fontSize: 11,
            fontWeight: 700,
            color: 'var(--t3)',
            textTransform: 'uppercase',
            letterSpacing: '.06em',
          }}>
            Service Notes
          </div>
          <textarea
            name="notes"
            placeholder="What was added, what was done, anything unusual…"
            style={{
              width: '100%',
              background: 'transparent',
              border: 'none',
              outline: 'none',
              padding: '12px 14px',
              fontFamily: 'inherit',
              fontSize: 13,
              color: 'var(--t1)',
              resize: 'none',
              minHeight: 80,
            }}
          />
        </div>

        <button type="submit" className="m-action primary" style={{ width: '100%', marginTop: 4 }}>
          <div className="m-action-icon">💾</div>
          <div className="m-action-label" style={{ fontSize: 14 }}>Save Chemistry</div>
        </button>
      </form>
    </div>
  );
}
